// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__AkVia","head":"Navbar_head__eNY7E","title":"Navbar_title__7PDyG","subTitle":"Navbar_subTitle__WwBcA","logout":"Navbar_logout__U+puI"};